import React from "react";
import moment from 'moment';

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
};
const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "名称",
      name: "nameSearch",
      searchItem: {}
    },
    {
      title: "名称",
      name: "name",
      tableItem: {
        width: 200,
      }
    },
    {
      title: "课件编号",
      name: "codeSearch",
      searchItem: {}
    },
    {
      title: "课件编号",
      name: "code",
      tableItem: {
        width: 200,
      }
    },
    {
      title: "平台",
      name: "channel",
      dict: [
        {code: 1, codeName: "scorm平台"},
      ],
      tableItem: {
        width: 100,
      },
      searchItem: {
        type: "select"
      }
    },
    {
      title: '最新更新时间',
      name: 'updateTime',
      dataIndex: "updateTime",
      tableItem: {
        width: 200,
        render: text => {
          return formatterDate(text)
        }
      },
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'coursewareManagement/listByPage',
    ...api
  }
}

const courseware = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    cols: {
      xs: 24,
      md: 12,
      xl: 8
    },
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    tableApi: tableApi(api)
  }
}

export default courseware
